// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Ref from 'models/propTypes/ref';
import Cue from 'models/propTypes/cue';
import CueStyle from 'models/propTypes/closedCaptions';

import styles from './CueStyleBox.module.scss';

const CueStyleBox = ({ cue, cueBoxRef, settings, style }) => {
  const {
    textSize,
    textColor,
    textType,
    textOpacity,
    textShadow,
    textShadowColor,
    backgroundColor,
    backgroundOpacity,
    windowColor,
    windowOpacity,
  } = settings;

  const { align, vertical, positionAlign, position, size } = cue;

  let textPos;
  switch (positionAlign) {
    case 'middle':
      textPos = position - size / 2;
      break;
    case 'end':
      textPos = position - size;
      break;
    case 'start':
    default:
      textPos = position;
  }

  const windowStyle = {};
  if (vertical === '') {
    windowStyle.left = `${textPos}%`;
    windowStyle.width = `${size}%`;
  } else {
    windowStyle.top = `${textPos}%`;
    windowStyle.height = `${size}%`;
  }

  return (
    <div
      className={classNames(
        styles.window,
        styles[`cue-align-${align}`],
        styles[`window-color-${windowColor}`],
        styles[`window-opacity-${windowOpacity}`],
        styles[`cue-veritcal-${vertical === '' ? 'horz' : vertical}`],
      )}
      style={{ ...windowStyle, ...style }}
      ref={cueBoxRef}
    >
      <div
        className={classNames(
          'd-inline-block',
          styles[`background-color-${backgroundColor}`],
          styles[`background-opacity-${backgroundOpacity}`],
        )}
      >
        <div
          className={classNames(
            styles.text,
            styles[textSize],
            styles[textType],
            styles[`text-color-${textColor}`],
            styles[`text-opacity-${textOpacity}`],
            styles[`text-shadow-${textShadow}`],
            styles[`text-shadow-color-${textShadowColor}`],
            styles[`writing-mode-${vertical === '' ? 'horz' : vertical}`],
          )}
          // After stripping out xml tags from the caption text
          // it may still contain html escaped characters like &gt;
          // setting inner html will allow for these characters to
          // display properly.
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: cue.text }}
        />
      </div>
    </div>
  );
};

CueStyleBox.propTypes = {
  cueBoxRef: Ref,
  cue: Cue.isRequired,
  settings: CueStyle.isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

CueStyleBox.defaultProps = {
  cueBoxRef: null,
  style: null,
};

export default React.forwardRef((props, ref) => {
  return <CueStyleBox {...props} cueBoxRef={ref} />;
});
